import { isValid, parseISO } from 'date-fns';
import { formatDate } from './format-date';

/**
 * Função que verifica se a data é válida, caso seja, retorna a data formatada, caso contrário retorna null.
 * @param {*} date
 * @returns retorna a data ou null
 */
export const isValidDate = (date) => {
  if (isValid(parseISO(date))) {
    return formatDate(date);
  }
  return null;
};
